// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_UPDATE_ASIGNACION_DE_LINEAS,
} from './constants';

export function updateAsignacionDeLineas(veicleType, asignacionLineas) {
  return {
    type: SIMULADOR_FINANCIERO_UPDATE_ASIGNACION_DE_LINEAS,
    asignacionLineas,
    veicleType,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_UPDATE_ASIGNACION_DE_LINEAS:
      if (state.editLinea) {
        return {
          ...state,
          veicleType: action.veicleType,
          editLineaData: {
            ...state.editLineaData,
            asignacionLineas: action.asignacionLineas
          }
        };
      } else {
        let datosFinancieros = state.altaNuevaLinea.datosFinancieros;
        return {
          ...state,
          veicleType: action.veicleType,
          altaNuevaLinea: {
            datosFinancieros: datosFinancieros,
            asignacionLineas: action.asignacionLineas
          }
        };
      }

    default:
      return state;
  }
}
